export { default as useCarouselRewards } from './use-carousel-rewards';
